/* web/app/components/layout/main/header/main-header.scss */
:root {
  --bs-modal-header-padding: 1rem;
  --bs-modal-header-border-width: 1px;
  --bs-modal-header-border-color:#dee2e6;
  --bs-modal-inner-border-radius: calc(.3rem - 1px);
  --bs-modal-padding: 1rem;
  --bs-modal-footer-gap: 0.5rem;
  --bs-modal-footer-border-width: 1px;
  --bs-modal-footer-border-color: #dee2e6;
}
main-header .navbar.navbar-1 {
  left: 0;
  z-index: 1;
  height: auto;
}
main-header .navbar.navbar-1 ul {
  width: 100%;
}
main-header .navbar.navbar-1 ul > li.lang-wrap {
  vertical-align: bottom;
}
main-header .navbar.navbar-1 ul > li.logo-wrap img {
  width: 80px;
}
main-header .navbar.navbar-1 ul > li a {
  color: #212121;
}
main-header .navbar.navbar-1 section.left ul.nav-list {
  text-align: left;
}
main-header .navbar.navbar-1 section.right ul.nav-list {
  text-align: right;
}
body.mat-sidenav-show main-header .navbar-mobile {
  background-color: #f3f3f3;
}
@media (min-width: 992px) {
  .fa-user {
    font-size: 1.2rem;
  }
}
body[dir=rtl] main-header .navbar.navbar-1 {
  left: 0;
}
body[dir=rtl] main-header .navbar.navbar-1 section.left ul.nav-list {
  text-align: right;
}
body[dir=rtl] main-header .navbar.navbar-1 section.right ul.nav-list {
  text-align: left;
}
/*# sourceMappingURL=main-header.css.map */
